export default "__VITE_PUBLIC_ASSET__2969487e__"